module.exports = __webpack_public_path__ + "static/combine-3961552d5976f4e7d3f47c4d2efd34e8.gif";